// src/routes/routeDefinitions.ts
import React from "react";
import LoginPage from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import SetNewPassword from "../pages/auth/SetNewPassword";
import PasswordChanged from "../pages/auth/PasswordChanged";
import Dashboard from "../pages/dashboard";
import ListofAdmins from "../pages/AdminManagement/ListofAdmins";
import AddAdmin from "../pages/AdminManagement/AddAdmin";
import ViewAdminDetails from "../pages/AdminManagement/ViewAdminDetails";
import OtherResources from "../pages/OtherResources/Banks";
import { Addbank } from "../pages/OtherResources/Banks/Addbank";
import RegionalOffice from "../pages/OtherResources/RegionalOffice";
import AddRegionalOffice from "../pages/OtherResources/RegionalOffice/AddRegionalOffice";
import NotFound from "../components/Notfound/Notfound";
import AddMD from "../pages/UserManagement/MasterDistributorManagement/AddMD";
import ListOfMasterDistributors from "../pages/UserManagement/MasterDistributorManagement/ListofMasterDistributor";
import ViewMasterDistributor from "../pages/UserManagement/MasterDistributorManagement/ViewMasterDistributor";
import ListofMNOs from "../pages/MNOManagament/ListofMNOs";
import AddMNO from "../pages/MNOManagament/AddMNO";
import ViewMnoDetails from "../pages/MNOManagament/ViewMnoDetails";
import ListofPurchasedAmount from "../pages/MNOManagament/ListOfPurchasedAmount";
import AddManual from "../pages/MNOManagament/AddManual";
import ViewManual from "../pages/MNOManagament/ViewManual";
import PayDueBill from "../pages/MNOManagament/PayDueBill";
import ListOfAchievements from "../pages/MNOManagament/OnTargetAchievement/ListOfAchievements";
import AddOnTargetAchievement from "../pages/MNOManagament/OnTargetAchievement/AddOnTargetAchievement";
import ETopUpRequest from "../pages/RaiseETopUpRequest";
import AddMnoTarget from "../pages/MNOManagament/OnTargetAchievement/AddMnoTarget";
import PayAdvance from "../pages/RaiseETopUpRequest/PayAdvance";
import ListOfServiceFeeTransaction from "../pages/MNOManagament/ServiceFeeTransaction/ListOfServiceFeeTransaction";
import ETopUpRequestList from "../pages/Profile/RequestRaised";
import ETopUpView from "../pages/Profile/RequestRaised/ETOpUpView";
import OnboardingRequest from "../pages/OnboardingRequest/ListOfOnboardingRequest";
import ViewOnBoardingRequests from "../pages/OnboardingRequest/ViewOnboardingRequest";
import ETopUpTransactionsLists from "../pages/Profile/RequestRaised/ETopUpTransactionsLists";
import AddCVM from "../pages/UserManagement/MasterDistributorManagement/Components/AddCVM";
import Recharge from "../pages/Services/Recharge";
import ListofCompanies from "../pages/CompanyManagement/ListofCompanies";
import AddCompany from "../pages/CompanyManagement/AddCompany";
import ViewCompanyDetails from "../pages/CompanyManagement/ViewCompanyDetails";
import ViewAdminProfile from "../pages/Profile/AdminProfile/ViewAdminProfile";
import UpdateAdminProfile from "../pages/Profile/AdminProfile/UpdateAdminProfile";
import ListOfAdminTransactions from "../pages/Profile/AdminProfile/AdminProfileTransactions";
import ViewTransaction from "../pages/Profile/AdminProfile/ViewTransaction";
import ReversalRequest from "../pages/ReversalRequest/ListOfReversalRequest";
import ViewReversalRequest from "../pages/ReversalRequest/ViewReversalRequest";
import BalanceSheet from "../pages/ZoodpayMoney/BalanceSheet";
import ListOfBankAccounts from "../pages/ZoodpayMoney/BalanceSheet/ListOfBankAccounts";
import ListOfBankTransactions from "../pages/ZoodpayMoney/BalanceSheet/ListOfBankTransactions";
import AddManualTransactions from "../pages/ZoodpayMoney/BalanceSheet/AddManualTransactions";
import ListOfSuperAdminTransactions from "../pages/ZoodpayMoney/SuperAdminTransactions/ListOfSuperAdminTransactions";
import ListOfJournalVoucher from "../pages/ZoodpayMoney/JournalVoucher/ListOfJournalVoucher";
import ListOfCVMServiceFee from "../pages/ZoodpayMoney/CVMServiceFee/ListOfCVMServiceFee";
import ViewCVMTargetDetails from "../pages/ZoodpayMoney/CVMServiceFee/ViewCVMTargetDetails";
import ListOfReversals from "../pages/ZoodpayMoney/Reversals/ListOfReversals";
import ViewSuperAdminTransaction from "../pages/ZoodpayMoney/SuperAdminTransactions/ViewSuperAdminTransaction";
import ListOfMnoTransactions from "../pages/ZoodpayMoney/Reversals/ListOfMnoTransactions";
import AddReversalTransaction from "../pages/ZoodpayMoney/Reversals/AddReversalTransaction";
import EtopupRecharge from "../pages/Reports/Reports";
import ListTickets from "../pages/support/ListTickets";
import ViewTicket from "../pages/support/ViewTicket";
import WalletTransfer from "../pages/bulk-transfer/wallet-transfer";
import ListWallet from "../pages/bulk-transfer/list-of-transfer";
import UpdateWallet from "../pages/bulk-transfer/edit-wallet";
import ListOfChildTransactions from "../pages/UserManagement/MasterDistributorManagement/ListOfChildTransactions";
import ViewTransactionDetails from "../pages/UserManagement/MasterDistributorManagement/Components/ViewTransactionDetails";
import ListOfLogs from "../pages/Logs";
import ListOfActiveChilds from "../pages/UserManagement/MasterDistributorManagement/ListOfActiveChilds";
import ViewLogDetails from "../pages/Logs/View";
import StockTransfer from "../pages/StockTransfer";
interface RouteDefinition {
  path: string;
  element: React.FC<any>; // Component for rendering
  props?: Record<string, any>; // Optional props for the component
  privilege?: any; // Optional privilege required for the route
}

export const unauthenticatedRoutes: RouteDefinition[] = [
  { path: "/", element: LoginPage },
  { path: "/forgot-password", element: ForgotPassword },
  { path: "/set-new-password", element: SetNewPassword },
  { path: "/password-changed", element: PasswordChanged },
  { path: "/expired", element: PasswordChanged }, // Duplicate reference for simplicity
];

export const authenticatedRoutes: RouteDefinition[] = [
  {
    path: "/dashboard",
    element: Dashboard,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins",
    element: ListofAdmins,
    privilege: "supper-admin-allowed",
  },
  {
    path: "/admin-management/list-of-admins/view-admin/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "supper-admin-allowed",
    props: { type: "ADM" },
  },
  {
    path: "/admin-management/list-of-admins/view-admin/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "supper-admin-allowed",
    props: { type: "ADM", isUserManagement: true, userType: 'ADM' },
  },
  {
    path: "/view-profile",
    element: ViewAdminProfile,
    privilege: "allowed",
  },
  {
    path: "/view-profile/transaction-details",
    element: ListOfAdminTransactions,
    privilege: "allowed",
  },
  {
    path: "/view-profile/transaction-details/:id",
    element: ViewTransaction,
    privilege: "allowed",
  },
  {
    path: "/view-profile/edit-profile",
    element: UpdateAdminProfile,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins/add-admin",
    element: AddAdmin,
    privilege: "allowed",
  },
  {
    path: "/admin-management/list-of-admins/view-admin/:id",
    element: ViewAdminDetails,
    privilege: "supper-admin-allowed",
  },
  {
    path: "/admin-management/list-of-admins/edit-admin/:id",
    element: AddAdmin,
    privilege: "supper-admin-allowed",
  },
  {
    path: "/admin-management/view-admin-profile/edit-admin/:id",
    element: AddAdmin,
    privilege: "supper-admin-allowed",
  },
  {
    path: "/user-management/master-distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["MDM1", "MDM4"],
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["DM1", "DM4"],
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management",
    element: ListOfMasterDistributors,
    privilege: ["SDM1", "SDM4"],
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management",
    element: ListOfMasterDistributors,
    privilege: ["AM1", "AM4"],
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management",
    element: ListOfMasterDistributors,
    privilege: ["RM1", "RM4"],
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management",
    element: ListOfMasterDistributors,
    privilege: ["CM1", "CM4"],
    props: { type: "Customers" },
  },
  {
    path: "/user-management/master-distributor-management/add-master-distributor",
    element: AddMD,
    privilege: "MDM4",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/master-distributor-management/add-master-distributor/add-cvm",
    element: AddCVM,
    privilege: "allowed",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/add-sub-distributor",
    element: AddMD,
    privilege: "SDM4",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management/add-agent",
    element: AddMD,
    privilege: "AM4",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management/add-retailer",
    element: AddMD,
    privilege: "RM4",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management/add-customer",
    element: AddMD,
    privilege: "AM4",
    props: { type: "Customers" },
  },
  {
    path: "/user-management/sub-distributor-management/edit-sub-distributor/:id",
    element: AddMD,
    privilege: "MDM5",
    props: { type: "Sub Distributors", edit: true },
  },
  {
    path: "/user-management/agent-management/edit-agent/:id",
    element: AddMD,
    privilege: "AM2",
    props: { type: "Agents", edit: true },
  },
  {
    path: "/user-management/retailer-management/edit-retailer/:id",
    element: AddMD,
    privilege: "RM2",
    props: { type: "Retailers", edit: true },
  },
  {
    path: "/user-management/distributor-management/add-distributor",
    element: AddMD,
    privilege: "DM4",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "MDM2",
    props: { type: "Master Distributors", privilege: "MDM7" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management/view-customer/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Customers" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Agents" },
  },
    {
    path: "/user-management/retailer-management/view-retailer/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/customer-management/view-customer/:id/transactions",
    element: ListOfChildTransactions,
    privilege: "allowed",
    props: { type: "Customers" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Master Distributors", isUserManagement: true, userType: 'MDST' },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Distributors", isUserManagement: true, userType: 'DST' },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Sub Distributors", isUserManagement: true, userType: 'SDST' },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Agents", isUserManagement: true, userType: 'AGT' },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Retailers", isUserManagement: true, userType: 'RET' },
  },
  {
    path: "/user-management/customer-management/view-customer/:id/transactions/:transactionId",
    element: ViewTransactionDetails,
    privilege: "allowed",
    props: { type: "Customers", isUserManagement: true, userType: 'CMR' },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id/add-cvm",
    element: AddCVM,
    privilege: "MDM2",
    props: { type: "Master Distributors", edit: true },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "DM6",
    props: { type: "Distributors", privilege: "DM7" },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id/add-cvm",
    element: AddCVM,
    privilege: "DM6",
    props: { type: "Distributors", edit: true },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id",
    element: ViewMasterDistributor,
    privilege: "SDM6",
    props: { type: "Sub Distributors", privilege: "SDM7" },
  },
    {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/add-cvm",
    element: AddCVM,
    privilege: "SDM6",
    props: { type: "Sub Distributors", edit: true },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/add-cvm",
    element: AddCVM,
    privilege: "SDM6",
    props: { type: "Sub Distributors", edit: true },
  },
  {
    path: "/user-management/agent-management/view-agent/:id",
    element: ViewMasterDistributor,
    privilege: "AM6",
    props: { type: "Agents", privilege: "AM7" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/add-cvm",
    element: AddCVM,
    privilege: "AM6",
    props: { type: "Agents", edit: true },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id",
    element: ViewMasterDistributor,
    privilege: "RM6",
    props: { type: "Retailers", privilege: "RM7" },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id/add-cvm",
    element: AddCVM,
    privilege: "RM6",
    props: { type: "Retailers", edit: true },
  },
  {
    path: "/user-management/customer-management/view-customer/:id",
    element: ViewMasterDistributor,
    privilege: "CM6",
    props: { type: "Customers", privilege: "CM7" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id/activate-childs",
    element: ListOfActiveChilds,
    privilege: "MDM7",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/master-distributor-management/view-master-distributor/:id/deactivate-childs",
    element: ListOfActiveChilds,
    privilege: "MDM7",
    props: { type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id/activate-childs",
    element: ListOfActiveChilds,
    privilege: "DM7",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/distributor-management/view-distributor/:id/deactivate-childs",
    element: ListOfActiveChilds,
    privilege: "DM7",
    props: { type: "Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/activate-childs",
    element: ListOfActiveChilds,
    privilege: "SDM7",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/sub-distributor-management/view-sub-distributor/:id/deactivate-childs",
    element: ListOfActiveChilds,
    privilege: "SDM7",
    props: { type: "Sub Distributors" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/activate-childs",
    element: ListOfActiveChilds,
    privilege: "AM7",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/agent-management/view-agent/:id/deactivate-childs",
    element: ListOfActiveChilds,
    privilege: "AM7",
    props: { type: "Agents" },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id/activate-childs",
    element: ListOfActiveChilds,
    privilege: "RM7",
    props: { type: "Retailers" },
  },
  {
    path: "/user-management/retailer-management/view-retailer/:id/deactivate-childs",
    element: ListOfActiveChilds,
    privilege: "RM7",
    props: { type: "Retailers" },
  },
  {
    path: "/other-resources/banks",
    element: OtherResources,
    privilege: "allowed",
  },
  {
    path: "/other-resources/banks/add-bank",
    element: Addbank,
    privilege: "allowed",
    props: { edit: false },
  },
  {
    path: "/other-resources/banks/edit-bank/:id",
    element: Addbank,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/other-resources/regional-offices",
    element: RegionalOffice,
    privilege: "allowed",
  },
  {
    path: "/other-resources/regional-offices/add-regional-office",
    element: AddRegionalOffice,
    privilege: "allowed",
    props: { edit: false },
  },
  {
    path: "/other-resources/regional-offices/edit-regional-office/:id",
    element: AddRegionalOffice,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/",
    element: Dashboard,
    privilege: "allowed",
  },
  {
    path: "/user-management/master-distributor-management/edit-master-distributor/:id",
    element: AddMD,
    privilege: "MDM5",
    props: { edit: true, type: "Master Distributors" },
  },
  {
    path: "/user-management/distributor-management/edit-distributor/:id",
    element: AddMD,
    privilege: "DM2",
    props: { edit: true, type: "Distributors" },
  },
  {
    path: "/user-management/customer-management/edit-customer/:id",
    element: AddMD,
    privilege: "CM2",
    props: { edit: true, type: "Customers" },
  },
  // MNO Management Routes
  {
    path: "/mno-management/list-of-mnos",
    element: ListofMNOs,
    privilege: ["MM1", "MM4"],
  },
  {
    path: "/mno-management/list-of-mnos/add-mno",
    element: AddMNO,
    privilege: "MM4",
  },
  {
    path: "/mno-management/list-of-mnos/edit-mno/:id",
    element: AddMNO,
    privilege: "MM2",
    props: { edit: true },
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id",
    element: ViewMnoDetails,
    privilege: "MM6",
    // props: { type: "Distributors" }
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement",
    element: ListOfAchievements,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/service-fee-transaction",
    element: ListOfServiceFeeTransaction,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target",
    element: AddMnoTarget,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target/:targetId",
    element: AddMnoTarget,
    privilege: "allowed",
    props: { edit: true },
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/on-target-achievement/add-on-target-achievement/:dataId",
    element: AddOnTargetAchievement,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction",
    element: ListofPurchasedAmount,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/add-manual",
    element: AddManual,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/view-manual/:purchaseId",
    element: ViewManual,
    privilege: "allowed",
  },
  {
    path: "/mno-management/list-of-mnos/view-mno/:id/purchased-amount-transaction/pay-due-bill/:dataId",
    element: PayDueBill,
    privilege: "allowed",
  },
  {
    path: "/e-top-up-request/e-top-up/raise-e-top-up-request",
    element: ETopUpRequest,
    privilege: "admin-allowed",
  },
  {
    path: "/e-top-up-request/e-top-up/raise-e-top-up-request/:tab",
    element: ETopUpRequest,
    privilege: "admin-allowed",
  },
  {
    path: "/e-top-up-request/e-top-up/raise-e-top-up-request/pay/:id",
    element: PayAdvance,
    privilege: "admin-allowed",
  },
  // {
  //     path: "/e-top-up-request",
  //     element: ETopUpRequestList,
  //     privilege: "supper-admin"
  // },
  {
    path: "/e-top-up-request/:tab",
    element: ETopUpRequestList,
    privilege: "allowed",
  },
  {
    path: "/e-top-up-request/e-top-up/:id",
    element: ETopUpView,
    privilege: "allowed",
    props: { default: true },
  },
  {
    path: "/e-top-up-request/transactions/:id",
    element: ETopUpTransactionsLists,
    privilege: "allowed",
    props: { default: true },
  },
  

  // Onboarding Request
  {
    path: "/onboarding-request",
    element: OnboardingRequest,
    privilege: ["OR1", "OR4"],
  },
  {
    path: "/onboarding-request/:tab",
    element: OnboardingRequest,
    privilege: ["OR1", "OR4"],
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/master-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Master Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/master-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Master Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/agent/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Agents", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/agent/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Agents", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/sub-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Sub Distributors", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/sub-distributor/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Sub Distributors", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/retailer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Retailers", tab: "Onboarding" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/customer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Customers", tab: "Onboarding" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/retailer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Retailers", tab: "Modification" },
  },
  {
    path: "/modification-request/:tab/view-modification-request/customer/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Customers", tab: "Modification" },
  },
  {
    path: "/onboarding-request/:tab/view-onboarding-request/temporary-user/:id",
    element: ViewOnBoardingRequests,
    privilege: ["OR4"],
    props: { type: "Temporary Users", tab: "Onboarding" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/master-distributor/:id",
    element: AddMD,
    privilege: "OR2",
    props: {
      type: "Master Distributors",
      edit: true,
      tab: "Onboarding Requests",
    },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/agent/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Agents", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/customer/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Customers", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Distributors", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/sub-distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Sub Distributors", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/modification-request/:tab/edit-modification-request/sub-distributor/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: {
      type: "Sub Distributors",
      edit: true,
      tab: "Modification Requests",
    },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/retailer/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Retailers", edit: true, tab: "Onboarding Requests" },
  },
  {
    path: "/onboarding-request/:tab/edit-onboarding-request/temporary-user/:id",
    element: AddMD,
    privilege: ["OR2"],
    props: { type: "Temporary Users", edit: true, tab: "Onboarding Requests" },
  },
  // Recharge flow
  {
    path: "/services/recharge",
    element: Recharge,
    privilege: ["S1", "S2"],
  },
  {
    path: "/services/stock-transfer",
    element: StockTransfer,
    privilege: "allowed",
  },
  {
    path: "/services/stock-transfer/:tab",
    element: StockTransfer,
    privilege: "allowed",
  },
  {
    path: "*",
    element: NotFound,
    privilege: "allowed",
    props: { default: true },
  },

  //company mangement
  {
    path: "/company-management",
    element: ListofCompanies,
    privilege: ["CMGT1", "CMGT4"],
  },
  {
    path: "/company-management/add-company",
    element: AddCompany,
    privilege: ["CMGT4"],
  },
  {
    path: "/company-management/view-company/:id",
    element: ViewCompanyDetails,
    privilege: ["CMGT2"],
  },
  {
    path: "/company-management/edit-company/:id",
    element: AddCompany,
    privilege: ["CMGT3"],
    props: { edit: true },
  },
  {
    path: "/company-management/view-company/edit-company/:id",
    element: AddCompany,
    privilege: ["CMGT3"],
    props: { edit: true },
  },

  // Reversal Requests
  {
    path: "/reversal-requests",
    element: ReversalRequest,
    privilege: ["RR1"],
  },
  {
    path: "/reversal-requests/view-reversal-request/:id",
    element: ViewReversalRequest,
    privilege: ["RR2"],
  },

  // Zoodpay Money - Balance Sheet
  {
    path: "/zoodpay-money/balance-sheet",
    element: BalanceSheet,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/balance-sheet/bank-accounts",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Bank Accounts", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bank-accounts/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Bank Accounts", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/cash-in-hand",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Cash in Hand", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/cash-in-hand/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Cash in Hand", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/mobile-money",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Mobile Money", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/mobile-money/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Mobile Money", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/mobile-money/:id/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Mobile Money", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/account-receivable-customers-gl",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Account Receivable (Customers) GL", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/account-receivable-customers-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Account Receivable (Customers) GL", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-mno-inventory-gl",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: {
      group_type: "Bundle Activation MNO Inventory GL",
      group: "Assets",
    },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-mno-inventory-gl",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Inventory GL", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-mno-inventory-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: {
      group_type: "Bundle Activation MNO Inventory GL",
      group: "Assets",
      reports: false
    },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-mno-inventory-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Inventory GL", group: "Assets", reports: false },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-mno-inventory-gl/:id/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Inventory GL", group: "Assets" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bank-charges",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Bank Charges", group: "Expenses" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bank-charges/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Bank Charges", group: "Expenses" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bank-charges/:id/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Bank Charges", group: "Expenses" },
  },

  // Zoodpay Money - Super Admin Transactions
  {
    path: "/zoodpay-money/super-admin-transactions",
    element: ListOfSuperAdminTransactions,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/super-admin-transactions/:id",
    element: ViewSuperAdminTransaction,
    privilege: "allowed",
  },
  // Zoodpay Money - Journal Voucher
  {
    path: "/zoodpay-money/journal-voucher",
    element: ListOfJournalVoucher,
    privilege: "allowed",
  },
  // Zoodpay Money - CVM Service Fee
  {
    path: "/zoodpay-money/cvm-service-fee",
    element: ListOfCVMServiceFee,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/cvm-service-fee/:id",
    element: ViewCVMTargetDetails,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/journal-voucher/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
  },
  // Zoodpay Money - Reversals
  {
    path: "/zoodpay-money/reversals/etopup-reversal",
    element: ListOfReversals,
    privilege: "allowed",
    props: { reversalType: "etopup" },
  },
  {
    path: "/zoodpay-money/reversals/recharge-reversal",
    element: ListOfReversals,
    privilege: "allowed",
    props: { reversalType: "recharge" },
  },
  {
    path: "/zoodpay-money/reversals/recharge-reversal/:id",
    element: ListOfMnoTransactions,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/balance-sheet/wallet",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Wallet", group: "Assets" },
  },
  {
    path: "/zoodpay-money/reversals/recharge-reversal/add-reversal",
    element: AddReversalTransaction,
    privilege: "allowed",
  },
  // Balance Sheet - Liabilities
  {
    path: "/zoodpay-money/balance-sheet/zoodpay-parent-payable",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "ZoodPay/Parent Payable", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/zoodpay-parent-payable/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "ZoodPay/Parent Payable", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-mno-payable-gl",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Payable GL", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-mno-payable-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Payable GL", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-mno-payable-gl",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Bundle Activation MNO Payable GL", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-mno-payable-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Bundle Activation MNO Payable GL", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/recovery-payable/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Recovery Payable", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/recovery-payable/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Recovery Payable", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/customer-stock/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Customer Stock GL", group: "Liabilities" },
  },
  {
    path: "/zoodpay-money/balance-sheet/customer-stock/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Customer Stock GL", group: "Liabilities" },
  },
  // Balance Sheet - Equity/Capital
  {
    path: "/zoodpay-money/balance-sheet/equity-capital/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Capital/Owner Equity", group: "Equity/Capital" },
  },
  {
    path: "/zoodpay-money/balance-sheet/equity-capital/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
    props: { group_type: "Capital/Owner Equity", group: "Equity/Capital" },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-service-fee-expense/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/balance-sheet/general-expense/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
  },
  {
    path: "/zoodpay-money/balance-sheet/cvm-commission/transactions/add-manual-entries",
    element: AddManualTransactions,
    privilege: "allowed",
  },
  // Balance Sheet - Revenue
  {
    path: "/zoodpay-money/balance-sheet/etopup-service-fee-revenue",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Etopup Service Fee Revenue", group: "Revenue" },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-service-fee-revenue/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup Service Fee Revenue", group: "Revenue" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-service-fee-revenue",
    element: ListOfBankAccounts,
    privilege: "allowed",
    props: { group_type: "Bundle Activation Service Fee Revenue", group: "Revenue" },
  },
  {
    path: "/zoodpay-money/balance-sheet/bundle-activation-service-fee-revenue/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Bundle Activation Service Fee Revenue", group: "Revenue" },
  },
  {
    path: "/zoodpay-money/balance-sheet/service-fee-expense",
    element: ListOfBankAccounts,
    privilege: "admin-allowed",
    props: { group_type: "Service Fee Expense", group: "Expenses" },
  },
  {
    path: "/zoodpay-money/balance-sheet/service-fee-expense/:id",
    element: ListOfBankTransactions,
    privilege: "admin-allowed",
    props: { group_type: "Service Fee Expense", group: "Expenses" },
  },
  {
    path: "/zoodpay-money/balance-sheet/etopup-service-fee-expense/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup Service Fee Expense", group: "Expenses" },
  },
  {
    path: "/zoodpay-money/balance-sheet/general-expense/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "General Expense", group: "Expenses", reports: false },
  },
  {
    path: "/zoodpay-money/balance-sheet/cvm-commission/transactions",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "CVM Commission", group: "Expenses", reports: false },
  },
  // Reports
  {
    path: "/reports/etopup-recharge",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "eTop Up Recharge Report", params: { page_number: 1, sort: "transaction_date+desc" } },
  },
  {
    path: "/reports/unsuccessful-transaction",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Unsuccessful Transaction Report", params: { page_number: 1, sort: "transaction_date+desc" } },
  },
  {
    path: "/reports/geographical-sales",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Geographical Sales Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/stock-transfer",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Stock Transfer Report", params: { page_number: 1, sort: "transaction_date+desc" } },
  },
  {
    path: "/reports/stock-account-statement",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Account Statement Report" },
  },
  {
    path: "/reports/money-accounts-statement",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Account Statement Report" },
  },
  // /reports/mno-service-fee-earned
  {
    path: "/reports/mno-service-fee-earned",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "MNO's Service Fee Earned Report", params: {page_number: 1, sort: "created_at+desc"} },
  },
  {
    path: "/reports/mno-etopup-purchase",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "MNO Wise eTop Up Purchase Report", params: { page_number: 1, sort: "processed_date+desc" } },
  },
  {
    path: "/reports/on-target-achievement-mno",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "On Target Achievement of MNO Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/mno-etopup-available-balance",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "MNO Wise eTop Up Available Balance Report", params: { page_number: 1, sort: "mno_name+desc" } },
  },
  {
    path: "/reports/mno-etopup-available-balance/bundle-activation-mno-inventory-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: {
      group_type: "Bundle Activation MNO Inventory GL",
      group: "Assets",
      reports: true
    },
  },
  {
    path: "/reports/mno-etopup-available-balance/etopup-mno-inventory-gl/:id",
    element: ListOfBankTransactions,
    privilege: "allowed",
    props: { group_type: "Etopup MNO Inventory GL", group: "Assets", reports: true },
  },
  // /reports/upfront-sales
  {
    path: "/reports/upfront-sales",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Upfront Sales Report" },
  },
  {
    path: "/reports/upfront-purchased",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "Upfront Purchase Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/merchant-customer-balance",
    element: EtopupRecharge,
    privilege: "R11",
    props: { type: "Merchant / Customer eTop Up Wallet Balance Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/recharge-reversal",
    element: EtopupRecharge,
    privilege: "R17",
    props: { type: "Reversal Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/etopup-stock-digital-wallet-reversal",
    element: EtopupRecharge,
    privilege: "R23",
    props: { type: "Reversal Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/etop-up-sales-trend",
    element: EtopupRecharge,
    privilege: "R13",
    props: { type: "MNO Wise Sales Trend Report", params: { page_number: 1, sort: "date+desc" } },
  },
  {
    path: "/reports/zoodpay-profitability",
    element: EtopupRecharge,
    privilege: "R14",
    props: { type: "ZoodPay Profitability Report", params: { page_number: 1 } },
  },
  {
    path: "/reports/cvm-report",
    element: EtopupRecharge,
    privilege: "allowed",
    props: { type: "CVM Report", params: { page_number: 1 } },
  },

  // Support
  {
    path: "/support/list-tickets",
    element: ListTickets,
    privilege: "allowed",
  }, {
    path: "/support/list-tickets/view-ticket/:ticketId",
    element: ViewTicket,
    privilege: ["ST2"],
  },
  {
    path: "/bulk-transfer",
    element: WalletTransfer,
    privilege: "allowed",
  },
  {
    path: "/bulk-transfer/list-of-transfer",
    element: ListWallet,
    privilege: "allowed",
  },
  {
    path: "/bulk-transfer/edit-record",
    element: UpdateWallet,
    privilege: "allowed",
  },
  {
    path: "/logs/user-activity-logs",
    element: ListOfLogs,
    privilege: "allowed",
  },
  {
    path: "/logs/fund-transfer-logs",
    element: ListOfLogs,
    privilege: "allowed",
  },
  {
    path: "/logs/reverse-fund-logs",
    element: ListOfLogs,
    privilege: "allowed",
  },
  {
    path: "/logs/user-activity-logs/:id",
    element: ViewLogDetails,
    privilege: "allowed",
  },
  {
    path: "/logs/fund-transfer-logs/:id",
    element: ViewLogDetails,
    privilege: "allowed",
  },
];

